import { Button, ButtonProps } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExportOutlined, FilePdfOutlined } from '@ant-design/icons';

interface Props extends ButtonProps {}
export default function ExportBtn(props: Props) {
  const { t } = useTranslation();
  return (
    <Button icon={<ExportOutlined />} type="primary" danger {...props}>
      {t('Export')}
    </Button>
  );
}

export function ExportPdfBtn(props: Props) {
  const { t } = useTranslation();
  return (
    <Button icon={<FilePdfOutlined />} type="primary" danger {...props}>
      {t('Export PDF')}
    </Button>
  );
}

export function ExportExcelBtn(props: Props) {
  const { t } = useTranslation();
  return (
    <Button icon={<FilePdfOutlined />} type="default" {...props}>
      {t('Export Excel')}
    </Button>
  );
}
